export const data = [
    {
        title: 'Increases plant resistance to stressful conditions',
        text: 'Wuxal helps plants to adapt to changing climatic and environmental conditions, which makes them resistant to stressful situations.',
    },
    {
        title: 'Provides balanced nutrition for plants',
        text: 'Wuxal contains a variety of trace elements that provide plants with all the necessary nutrients for healthy growth and development.',
    },
    {
        title: 'Improves the quality of the crop',
        text: 'The use of Wuxal helps to improve the quality of fruits and plant products, making the harvest more attractive to the market.',
    },
    {
        title: 'Easily absorbed by plants',
        text: "Wuxal's formula is designed to make trace elements easily absorbed by plants, which helps to quickly achieve the desired results.",
    },
];

export const data2 = [
    {
        title: 'Crop Protection Synergy',
        type: 'full',
        text: 'An ideal partner in modern crop protection programs** for various crops. At a concentration of 0.1% (100 ml per 100 liters of water), it normalizes the pH to a neutral level (pH 7), which is optimal for the action of most plant protection products and for the effective absorption of nutrients through the leaf.',
    },
    {
        title: 'Unique Nutrient Fusion',
        text: 'The high content of both phosphorus and zinc is an exclusive combination.',
    },
    {
        title: 'Universal Compatibility',
        text: 'Wuxal Р Мах is compatible with most plant protection products.',
    },
    {
        title: 'Precise supply of nutrients',
        text: 'A balanced composition of fully EDTA-chelated trace elements.The presence of an adhesive and surfactant optimizes the effect of plant protection products and ensures rapid absorption of nutrients.',
    },
    {
        title: 'Enhanced Absorption',
        text: 'The presence of an adhesive and surfactant optimizes the effect of the plant protection product and ensures rapid absorption of nutrients.',
    },
];
